import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MatAnchor} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';

@Component({
  selector: 'pub-select-all-none-buttons',
  templateUrl: './select-all-none-buttons.component.html',
  styleUrls: ['./select-all-none-buttons.component.scss'],
  standalone: true,
  imports: [MatAnchor, MatIcon]
})
export class SelectAllNoneButtonsComponent {
  @Input() allSelected: boolean = false;
  @Input() singleSelected: boolean = false;

  @Output() toggleAll = new EventEmitter<boolean>();

  selectAllLabel = $localize`:@@selectAllNoneButtons.selectAll:Select All`;
  noneLabel = $localize`:@@selectAllNoneButtons.none:None`;

  selectAll() {
    this.select(true);
  }

  selectNone() {
    this.select(false);
  }

  private select = (value: boolean) => {
    this.allSelected = value;
    this.singleSelected = !value;
    this.toggleAll.emit(value);
  }
}
